import { BasicOnOff } from "@smartsuite/react-ui/lib/components/forms/BasicOnOff/BasicOnOff";
import { FieldLabel } from "@smartsuite/react-ui/lib/components/forms/FieldLabel/FieldLabel";
import React from "react";

export interface DirectionTogglesProps {
  title: string;
}

export const DirectionsToggles: React.FC<DirectionTogglesProps> = ({
  title,
}) => {
  return (
    <div>
      <FieldLabel>{title}</FieldLabel>
      <div className="toggle-directions">
        <div className="toggle-directions__border-background"></div>
        <div className="toggle-directions__extremity">
          <div className="slot">
            <BasicOnOff
              isChecked={false}
              size="xs"
              showCaption={false}
              onChange={() => false}
            />
          </div>
        </div>
        <div className="toggle-directions__middle">
          <div className="slot">
            <BasicOnOff
              isChecked={false}
              size="xs"
              showCaption={false}
              onChange={() => false}
            />
          </div>
          <div className="slot">
            <BasicOnOff
              isChecked={false}
              size="xs"
              showCaption={false}
              onChange={() => false}
            />
          </div>
        </div>
        <div className="toggle-directions__extremity">
          <div className="slot">
            <BasicOnOff
              isChecked={false}
              size="xs"
              showCaption={false}
              onChange={() => false}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
